export default __webpack_public_path__ + "static/media/swatch.f9691d16.jpg";